import React, { useState, useEffect, Children } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { node } from "prop-types";
import { set, get } from "@Core/LocalStorage";
import actions from './../../../Redux/Action'
import { PopUp } from "@Core/Library"
import { remove } from '@Core/LocalStorage';
import { toast } from 'react-toastify';


const Layout = ({ Component, ...props }) => {
  const history = useHistory();
  const dispatch = useDispatch()
  const srmwuiCustomerObj = get('srmwuiCustomerObj') || {}
  const userToken = srmwuiCustomerObj && Object.keys(srmwuiCustomerObj).length ? srmwuiCustomerObj.userToken : '';
  const userData = srmwuiCustomerObj && Object.keys(srmwuiCustomerObj).length ? srmwuiCustomerObj.userData :  {};
  const [homeRoute, setHomeRoute] = useState([]);
  const [isMobileState, toggleIsMobile] = useState(Boolean(window.innerWidth < 767));


  const handleResize = () => {
    toggleIsMobile(Boolean(window.innerWidth < 767));
  };

  useEffect(() => {
    // getting resize resolution  of browser 
    toggleIsMobile(Boolean(window.innerWidth < 767));
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };

  }, []);

  const clearAllData = () => {
    remove('srmwuiCustomerObj');
    dispatch(actions.CommonActions.setLoggedIn(false))
    dispatch(actions.CommonActions.setUserToken(''))
    dispatch(actions.CommonActions.SetLoginFormData({ isLoginForm:false, error:{}}))
    dispatch(actions.CommonActions.SetHomeData({rewardsEnrollTermsConditions:false, sscTermsConditions:false,migrationTermsConditions:false,error:{}}))
  }

  const handleLogout = (tokenVal) => {
    dispatch(actions.CommonActions.setLoading(true));
    let data = {
      appTraceId: "string",
      userId: userData ? userData.userId : "",
      userToken: tokenVal,
    }
    dispatch(actions.CommonActions.Logout(tokenVal, data, (res) => {
      if (res && res.status == 200) {
        clearAllData();
        dispatch(actions.CommonActions.setLoading(false));
      }
      else {
        clearAllData();
        dispatch(actions.CommonActions.setLoading(false));
      }
    }))
  }

  return (
    <Component {...props} userToken={userToken} userData={userData} homeRoute={homeRoute} handleLogout={handleLogout} clearAllData={clearAllData}/>
  );
};

Layout.propTypes = {
  children: node.isRequired,
};

export default Layout;
